import React from "react";
import Callicon from "../../asset/images/call-icon.svg";
import Envelope from "../../asset/images/envelope.svg";
import { Constants } from "../../CommonMethhods/Constants";

function Formfooter() {
  return (
    <div className="form-bottom-wrapper">
      {/* <div className="info-container">
        <a href="/">Membership Details</a>
        <a href="/">Need Help?</a>
      </div>
      <div className="social">
        <a className="mail" href="mailto:connect@bajajfinserv.in">
          <img src={Envelope} alt="" /> connect@bajajfinserv.in
        </a>
        <a className="phone" href="tel:18008338888">
          <img src={Callicon} alt="" /> 18008338888
        </a>
      </div> */}
      <p className="copyright">&#169; {Constants.Copyright_Bajaj}</p>
    </div>
  );
}

export default Formfooter;
